var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-content-placeholder',{attrs:{"icon":"cached","prompt-text":"Uploads in progress..."},scopedSlots:_vm._u([{key:"message",fn:function(){return [_vm._v(" References ready for review will appear here. ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }